import React, { useState, useMemo } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const B = {
  gold: "#D4A843", green: "#43B581", red: "#E74C3C",
  bg: "#0D0F13", card: "#13161C", border: "#1E222A",
  white: "#F0F0F0", whiteGray: "#A0A8B8", gray: "#6B7280",
};

const inputStyle = {
  width: "100%", padding: "10px 14px", marginBottom: 12, borderRadius: 8,
  border: "1px solid #2A2E36", background: "#0D0F13", color: "#F0F0F0",
  fontSize: 14, outline: "none", boxSizing: "border-box",
};

const formatErr = (d) => typeof d === "string" ? d : Array.isArray(d) ? d.map(e => e?.msg || "").join(", ") : "Something went wrong.";

const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const token = useMemo(() => new URLSearchParams(window.location.search).get("token") || "", []);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!token) { setError("Reset link is missing its token. Please request a new link."); return; }
    if (password.length < 6) { setError("Password must be at least 6 characters."); return; }
    if (password !== confirm) { setError("Passwords do not match."); return; }
    setBusy(true);
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/reset-password`,
        { token, new_password: password });
      setDone(true);
    } catch (err) {
      setError(formatErr(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="reset-password-page" style={{ minHeight: "100vh", background: B.bg, display: "flex", alignItems: "center", justifyContent: "center", padding: 24, fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
      <div style={{ background: B.card, borderRadius: 16, padding: 36, border: `1px solid ${B.border}`, maxWidth: 420, width: "100%", position: "relative" }}>
        <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 3, background: `linear-gradient(90deg, transparent, ${B.gold}, transparent)`, borderRadius: "16px 16px 0 0" }} />
        <img src="/flexx-logo.png" alt="FLEXX" style={{ height: 36, display: "block", margin: "0 auto 8px" }} onError={e => { e.target.style.display = "none"; }} />
        <div style={{ textAlign: "center", fontSize: 10, letterSpacing: 2, color: B.gold, fontFamily: "monospace", marginBottom: 24 }}>TRADING ACADEMY</div>

        {done ? (
          <>
            <h2 data-testid="reset-success-title" style={{ color: B.green, fontSize: 18, margin: "0 0 12px", textAlign: "center" }}>Password updated</h2>
            <p style={{ color: B.whiteGray, fontSize: 13, lineHeight: 1.6, textAlign: "center", marginBottom: 20 }}>
              Your password has been reset. You can now sign in with your new password.
            </p>
            <button data-testid="reset-go-home-btn" onClick={() => navigate("/")}
              style={{ width: "100%", padding: "12px 0", border: "none", borderRadius: 8, background: B.gold, color: "#000", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>
              Back to Home
            </button>
          </>
        ) : (
          <>
            <h2 style={{ color: B.white, fontSize: 18, margin: "0 0 8px", textAlign: "center" }}>Reset your password</h2>
            <p style={{ color: B.whiteGray, fontSize: 12, textAlign: "center", marginBottom: 20 }}>Choose a new password to secure your account.</p>
            <form onSubmit={submit}>
              <div style={{ position: "relative", marginBottom: 12 }}>
                <input data-testid="reset-new-password-input"
                  type={showPwd ? "text" : "password"} placeholder="New password (min 6 chars)"
                  value={password} onChange={e => setPassword(e.target.value)} required minLength={6}
                  style={{ ...inputStyle, marginBottom: 0, paddingRight: 42 }} />
                <button type="button" data-testid="reset-password-toggle-btn" onClick={() => setShowPwd(!showPwd)}
                  style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", background: "transparent", border: "none", cursor: "pointer", padding: 4, color: showPwd ? B.gold : B.gray, fontSize: 12 }}>
                  {showPwd ? "Hide" : "Show"}
                </button>
              </div>
              <input data-testid="reset-confirm-password-input"
                type={showPwd ? "text" : "password"} placeholder="Confirm new password"
                value={confirm} onChange={e => setConfirm(e.target.value)} required minLength={6}
                style={inputStyle} />
              {error && <div data-testid="reset-error" style={{ color: B.red, fontSize: 13, marginBottom: 12, textAlign: "center" }}>{error}</div>}
              <button data-testid="reset-submit-btn" type="submit" disabled={busy}
                style={{ width: "100%", padding: "12px 0", border: "none", borderRadius: 8, background: B.gold, color: "#000", fontSize: 14, fontWeight: 700, cursor: busy ? "wait" : "pointer", opacity: busy ? 0.7 : 1 }}>
                {busy ? "Resetting..." : "Reset Password"}
              </button>
            </form>
            <button data-testid="reset-back-to-signin" onClick={() => navigate("/")}
              style={{ marginTop: 16, width: "100%", background: "transparent", border: "none", color: B.gray, fontSize: 12, cursor: "pointer" }}>
              Back to sign in
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ResetPasswordPage;
